import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Swal from 'sweetalert2';
import { RecotizarService } from '../../services/recotizar.service';

@Component({
    selector: 'app-modal-recotizar',
    templateUrl: './modal-recotizar.component.html',
    styleUrls: ['./modal-recotizar.component.scss'],
    standalone: false
})
export class ModalRecotizarComponent implements OnInit {
	@Output() close = new EventEmitter<void>();
	@Input() proposalId?: string;
	@Input() observation?: string;

	requoteDescription: string = '';

	constructor(private recotizarService: RecotizarService) {}

	ngOnInit(): void {
		if (this.observation) {
			this.requoteDescription = this.observation;
		}
	}

	closeModal() {
		this.close.emit();
	}

	requestRequotation() {
		if (!this.proposalId || !this.requoteDescription.trim()) {
			Swal.fire({
				title: '¡Atención!',
				text: 'Por favor, escriba una descripción para la recotización.',
				icon: 'warning',
				confirmButtonText: 'Ok',
				showCloseButton: true,
				buttonsStyling: false,
				customClass: {
					confirmButton: 'btn btn-primary',
				},
			});
			return;
		}

		Swal.fire({
			title: '¡Atención!',
			text: `Estamos creando una nueva versión, por favor espere...`,
			icon: 'warning',
			allowEscapeKey: false,
			allowOutsideClick: false,
			showConfirmButton: false,
			didOpen: () => {
				Swal.showLoading();
			},
		});

		this.recotizarService.recotizarProposta(this.proposalId, this.requoteDescription).subscribe({
			next: () => {
				Swal.fire({
					title: '¡Éxito!',
					icon: 'success',
					text: '¡Recotización enviada con éxito!',
					confirmButtonText: 'Ok',
					showCloseButton: true,
					buttonsStyling: false,
					customClass: {
						confirmButton: 'btn btn-primary',
					},
				}).then(() => {
					Swal.hideLoading();
					this.closeModal();
				});
			},
			error: err => {
				Swal.fire({
					title: '¡Error!',
					text: 'Ocurrió un error al enviar la recotización.',
					icon: 'error',
					confirmButtonText: 'Ok',
					showCloseButton: true,
					buttonsStyling: false,
					customClass: {
						confirmButton: 'btn btn-primary',
					},
				});
				Swal.hideLoading();
			},
		});
	}
}
